import React from 'react';
import {StyleSheet, View} from 'react-native';

import {backgroundWelcome} from '../../assets/images';
import {Button} from '../../components/Button/Button';
import {ImgBackground} from '../../components/ImgBackground';
import {Logo} from '../../components/Logo';
import {SafeAreaView} from '../../components/SafeAreaView';
import {Text} from '../../components/Typography';
import {texts} from '../../constants/Strings';
import {Strings} from '../../constants/Strings';
import {Screens} from '../../constants/navigation';
import {useBreakpoints} from '../../lib/hooks/useBreakpoints';
import {RootStackScreenProps} from '../../navigators/RootStackNavigator';
import {colors} from '../../styles';
import {requestFullscreen} from '../../util/Fullscreen';

interface ScreenProps extends RootStackScreenProps<typeof Screens.Welcome> {}

export const WelcomeScreen: React.FC<ScreenProps> = ({navigation}) => {
  const {screenHeight} = useBreakpoints();

  return (
    <ImgBackground
      imageStyle={{
        height: `${Math.max(100, (2.35 - 0.0015 * screenHeight) * 100)}%`,
      }}
      source={backgroundWelcome}>
      <SafeAreaView style={styles.container}>
        <View style={styles.textContainer}>
          <Logo style={styles.logo} color={colors.black} size={40} />

          <Text style={styles.welcomeSubtitle} variant="lead">
            {texts.screens.welcome.subtitle}
          </Text>

          <Text style={styles.welcomeTitle} variant="h1">
            {texts.screens.welcome.title}
          </Text>
        </View>

        <View style={styles.buttonContainer}>
          <Button
            theme="black"
            onPress={() => {
              requestFullscreen();
              navigation.navigate(Screens.ValueProp);
            }}>
            {Strings.GET_STARTED}
          </Button>
        </View>
      </SafeAreaView>
    </ImgBackground>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
  },
  textContainer: {
    alignItems: 'center',
    flex: 1,
  },
  logo: {
    marginVertical: 40,
  },
  welcomeTitle: {
    color: colors.black,
    textAlign: 'center',
    marginHorizontal: 16,
  },
  welcomeSubtitle: {
    color: colors.iconGray,
    textTransform: 'uppercase',
    marginBottom: 16,
  },
  buttonContainer: {
    width: '100%',
    padding: 24,
    marginTop: 24,
  },
});
